import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

const initialState = {
  list: [],
  count: 0,
  tags: [],
  isLoading: false,
  isLoaded: false,
  filters: {
    page: 1,
    page_size: 10,
    search: '',
    tag: '',
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.GET_LINK_DISTRIBUTIONS[REQUEST]:
      return { ...state, isLoading: true, isLoaded: false };
    case ActionTypes.CREATE_LINK_DISTRIBUTION[REQUEST]:
    case ActionTypes.UPDATE_LINK_DISTRIBUTION[REQUEST]:
    case ActionTypes.DELETE_LINK_DISTRIBUTION[REQUEST]:
      return { ...state, isLoading: true };

    case ActionTypes.GET_LINK_DISTRIBUTIONS[SUCCESS]: {
      const list = Array.isArray(payload) ? payload : payload?.results || [];
      const count = Array.isArray(payload) ? payload.length : payload?.count || 0;

      return {
        ...state,
        list,
        count,
        isLoading: false,
        isLoaded: true,
      };
    }

    case ActionTypes.GET_LINK_DISTRIBUTIONS[FAILURE]:
    case ActionTypes.CREATE_LINK_DISTRIBUTION[FAILURE]:
    case ActionTypes.UPDATE_LINK_DISTRIBUTION[FAILURE]:
    case ActionTypes.DELETE_LINK_DISTRIBUTION[FAILURE]:
      return { ...state, isLoading: false };

    case ActionTypes.CREATE_LINK_DISTRIBUTION[SUCCESS]:
    case ActionTypes.UPDATE_LINK_DISTRIBUTION[SUCCESS]:
    case ActionTypes.DELETE_LINK_DISTRIBUTION[SUCCESS]:
      return { ...state, isLoading: false };

    case ActionTypes.GET_TAGS[SUCCESS]:
      return { ...state, tags: payload || [] };

    case ActionTypes.SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...payload } };

    default:
      return state;
  }
};
